import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "tips-info",
  style: {"margin-top":"32px"}
}, "未成交部分将全部撤单", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": _ctx.dialogVisible,
    title: "撤单确认",
    width: "600px",
    "destroy-on-close": "",
    center: "",
    "show-close": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        class: "content-close",
        onClick: _ctx.close
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        class: "content-confirm",
        Select: "",
        onClick: _ctx.confirm,
        loading: _ctx.loading,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_table, {
        "row-class-name": "table-row-hover",
        data: _ctx.data,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "姓名/账号",
            width: "110px"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(scope.row.nameCn), 1),
              _createElementVNode("div", null, _toDisplayString(scope.row.fundAccount), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "stockName",
            width: "116px",
            label: "股票名称/代码"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(scope.row.stockName), 1),
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(scope.row.stockCode), 1),
                _createElementVNode("span", {
                  class: _normalizeClass([_ctx.mktClass(scope.row.exchangeType), "mkt"])
                }, _toDisplayString(scope.row.exchangeType), 3)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "entrustPrice",
            width: "144px",
            label: "委托数量/委托价格"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(_ctx.numFormat(scope.row.entrustAmount, 0)), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.numFormat(scope.row.entrustPrice, 3)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "订单类型",
            width: "80px"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.ENTRUSTPROPMAP[scope.row.entrustProp]), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "交易状态" }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.STATES[scope.row.entrustStatus]), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _hoisted_1
    ]),
    _: 1
  }, 8, ["model-value"]))
}